module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MTQuMTY3IiBoZWlnaHQ9IjQyNy44NCIgdmlld0JveD0iMCAwIDUxNC4xNjcgNDI3Ljg0Ij4KICA8cGF0aCBpZD0i44OR44K5XzM3NDgiIGRhdGEtbmFtZT0i44OR44K5IDM3NDgiIGQ9Ik0tMjg1Ljg4LDQ1Mi4wODNWMjE5LjExOUwyMjguMjg2LDI0LjI0NFYyNTcuMjA4WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjg1Ljg4MSAtMjQuMjQ0KSIgZmlsbD0icmVkIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/red_514.svg
// module id = pbeR
// module chunks = 0